import { StyledOrdersContainer } from "../../orders-dashboard/style";
import { AdminStatisticsCard, CompactStatisticsCard } from "./StatisticsCard";
import { StyledStatsGrid, StyledCompactStatsGrid } from "./style";

const DashboardStatistics = ({ background, idDataList, hideFooter }) => {
  return (
    <StyledOrdersContainer background={background}>
      <StyledStatsGrid>
        {idDataList?.map((val, ind) => (
          <AdminStatisticsCard
            key={ind}
            title={val.title}
            count={val.value}
            changePercent={10}
            Icon={val.icon}
            hideFooter={hideFooter}
          />
        ))}
      </StyledStatsGrid>
    </StyledOrdersContainer>
  );
};

const CompactStatistics = ({ background, idDataList }) => {
  return (
    <StyledOrdersContainer background={background}>
      <StyledCompactStatsGrid>
        {idDataList?.map((val, ind) => (
          <CompactStatisticsCard
            key={ind}
            title={val.title}
            count={val.value}
            changePercent={10}
            Icon={val.icon}
          />
        ))}
      </StyledCompactStatsGrid>
    </StyledOrdersContainer>
  );
};

export { DashboardStatistics, CompactStatistics };
